export default __webpack_public_path__ + "static/media/buffer.d2b9eed8.svg";